<template>
  <div class="risk">
    <div class="risk_nav">
      <div class="risk_title">船舶信息</div>
    </div>
    <div class="risk_info_box">
      <div class="risk_info_one">
        <div class="risk_info_title">
          船名:
        </div>
        <div class="risk_info_value">
          {{ship.name_cn || ship.name_en}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          MMSI:
        </div>
        <div class="risk_info_value">
          {{ship.mmsi}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          类型:
        </div>
        <div class="risk_info_value">
          {{ship.ship_type_others}}
        </div>
      </div>
    </div>
    <div class="risk_nav">
      <div class="risk_title">综合评级</div>
    </div>
    <div class="risk_head">
      <div class="risk_head_left">
        <div class="risk_head_left_one">
          <div class="risk_head_left_one_bar risk_bar_color_one"></div>
          <div class="risk_head_left_one_title">
            属性评分
          </div>
          <div class="risk_head_left_star">
            <Star color="#0098fa" :score="risk.infStar"></Star>
          </div>
        </div>
        <div class="risk_head_left_one">
          <div class="risk_head_left_one_bar risk_bar_color_two"></div>
          <div class="risk_head_left_one_title">
            行为评分
          </div>
          <div class="risk_head_left_star">
            <Star color="#0cd9b5" :score="risk.aisStar"></Star>
          </div>
        </div>
        <div class="risk_head_left_one">
          <div class="risk_head_left_one_bar risk_bar_color_three"></div>
          <div class="risk_head_left_one_title">
            运营评分
          </div>
          <div class="risk_head_left_star">
            <Star color="#3b72ad" :score="risk.opScore"></Star>
          </div>
        </div>
        <div class="risk_head_left_one">
          <div class="risk_head_left_one_bar risk_bar_color_four"></div>
          <div class="risk_head_left_one_title">
            环境评分
          </div>
          <div class="risk_head_left_star">
            <Star color="#fdcc00" :score="risk.externalStar"></Star>
          </div>
        </div>
        <div class="risk_head_left_one">
          <div class="risk_head_left_one_bar risk_bar_color_five"></div>
          <div class="risk_head_left_one_title">
            事故评分
          </div>
          <div class="risk_head_left_star">
            <Star color="#f27629" :score="risk.malfunctionStar"></Star>
          </div>
        </div>
      </div>
      <div class="risk_head_right">
        <div class="risk_head_right_title">综合评分</div>
        <div class="risk_head_right_score">{{risk.riskScore}}</div>
        <div class="risk_head_right_star">
          <el-rate :disabled="true" v-model="risk.riskScore">
          </el-rate>
        </div>
      </div>
    </div>
    <div class="risk_nav">
      <div class="risk_title">风险提示</div>
      <div class="risk_alarm_count">
        {{riskReasonLen > 0 ? riskReasonLen + '条' : '无'}}
      </div>
    </div>
    <div class="risk_info_box">
      <div class="risk_alarm" v-if="riskReason.riskReansonA">
        <div class="risk_alarm_title">
          违规次数:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonA}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonB">
        <div class="risk_alarm_title">
          过去六个月违规次数:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonB}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonC">
        <div class="risk_alarm_title">
          违规评分:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonC}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonD">
        <div class="risk_alarm_title">
          PSC检查数:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonD}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonE">
        <div class="risk_alarm_title">
          PSC扣留数:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonE}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonF">
        <div class="risk_alarm_title">
          一年内PSC扣留数:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonF}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonG">
        <div class="risk_alarm_title">
          PSC评分:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonG}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonH">
        <div class="risk_alarm_title">
          管理公司评级:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonH}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonK">
        <div class="risk_alarm_title">
          AIS信号质量:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonK}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonL">
        <div class="risk_alarm_title">
          吨位船龄区间:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonL}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonM">
        <div class="risk_alarm_title">
          船龄区间:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonM}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonX">
        <div class="risk_alarm_title">
          事故评级:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonX}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonP">
        <div class="risk_alarm_title">
          八个月经过海盗区占比:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonP || '-'}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonQ">
        <div class="risk_alarm_title">
          八个月国内桥梁穿越次数:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonQ || '-'}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonW">
        <div class="risk_alarm_title">
          八个月穿越战区轨迹占比:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonW || '-'}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonR">
        <div class="risk_alarm_title">
          疑似沙滩船:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonR || '-'}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonZ">
        <div class="risk_alarm_title">
          疑似不活跃船舶:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonZ || '-'}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonT">
        <div class="risk_alarm_title">
          恶劣气候:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonT || '-'}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonSMC">
        <div class="risk_alarm_title">
          持有SMC船舶:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonSMC || '-'}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonDOC">
        <div class="risk_alarm_title">
          持有DOC船舶:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonDOC || '-'}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonHON">
        <div class="risk_alarm_title">
          海事局安全信任船舶:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonHON || '-'}}
        </div>
      </div>
      <div class="risk_alarm" v-if="riskReason.riskReansonTRA">
        <div class="risk_alarm_title">
          海事局重点跟踪船舶:
        </div>
        <div class="risk_alarm_value">
          {{riskReason.riskReansonTRA || '-'}}
        </div>
      </div>
    </div>
    <div class="risk_nav">
      <div class="risk_title">属性评级</div>
      <Star color="#0098fa" :score="risk.infStar"></Star>
    </div>
    <div class="risk_info_box">
      <div class="risk_info_one">
        <div class="risk_info_title">
          吨位:
        </div>
        <div class="risk_info_value">
          {{ship.gt}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          长 / 宽 (米):
        </div>
        <div class="risk_info_value">
          {{ship.length/10}} / {{ship.width/10}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          建造时间:
        </div>
        <div class="risk_info_value">
          {{ship.date_build ? new Date(ship.date_build*1000).toLocaleDateString() : (ship.date_keel_laid != 0 ? new Date(ship.date_keel_laid*1000).toLocaleDateString() : '-')}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          船旗:
        </div>
        <div class="risk_info_value">
          {{ ship.flag_name || ship.flag_name_en}}
        </div>
      </div>
    </div>
    <div class="risk_nav">
      <div class="risk_title">行为评级</div>
      <Star color="#0cd9b5" :score="risk.aisStar"></Star>
    </div>
    <div class="risk_info_box">
      <div class="risk_info_one">
        <div class="risk_info_title">
          过去八个月行为数据
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          总航程:
        </div>
        <div class="risk_info_value">
          {{risk.distanceSum}} {{risk.distanceSum?'海里':'-'}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          AIS信号:
        </div>
        <div class="risk_info_value">
          {{risk.dataAisQualityCombScore}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          活跃时段:
        </div>
        <div class="risk_info_value">
          {{risk.dailityActivityTimeSlot}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          航行速度:
        </div>
        <div class="risk_info_value">
          {{risk.speedMean}} {{risk.speedMean?'节':'-'}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          设计航速:
        </div>
        <div class="risk_info_value">
          {{ ship_speed.in_set_speed && ship_speed.in_set_speed > 0 ? ship_speed.in_set_speed : '' }}  {{ ship_speed.in_set_speed && ship_speed.in_set_speed > 0 ? '节' : '-' }}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          超设计航速时间占比:
        </div>
        <div class="risk_info_value">
          {{ship_speed.in_set_speed_ratio?((10000 - ship_speed.in_set_speed_ratio * 10000)/100)+'%':'-'}}
        </div>
      </div>
    </div>
    <div class="risk_nav">
      <div class="risk_title">运营评级</div>
      <Star color="#3b72ad" :score="risk.opScore"></Star>
    </div>
    <div class="risk_info_box">
      <div class="risk_info_one">
        <div class="risk_info_title">
          违规次数:
        </div>
        <div class="risk_info_value">
          {{risk.riskNum}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          PSC检查次数:
        </div>
        <div class="risk_info_value">
          {{ inspections ? inspections.length : 0}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          PSC扣留次数:
        </div>
        <div class="risk_info_value">
          {{risk.pscDetentionNum}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          管理公司:
        </div>
        <div class="risk_info_value">
          {{ship.name_show ? ship.name_show : '-'}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          管理公司信用评级:
        </div>
        <div class="risk_info_value">
          {{ship.credit_score || '-'}}
        </div>
      </div>
    </div>
    <div class="risk_nav">
      <div class="risk_title">环境评级</div>
      <Star color="#fdcc00" :score="risk.externalStar"></Star>
    </div>
    <div class="risk_info_box">
      <div class="risk_info_one">
        <div class="risk_info_title">
          实际航区:
        </div>
        <div class="risk_info_value">
          {{ risk.firstSecond || '-'}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          途径战区:
        </div>
        <div class="risk_info_value" v-html="risk_route.war_zone_str || '-'">
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          途径海盗频发区:
        </div>
        <div class="risk_info_value" v-html="risk_route.pirate_str || '-'">
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          穿越桥梁次数:
        </div>
        <div class="risk_info_value">
          {{ risk_route.bridge_sum || 0}}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          遭遇大风占比:
        </div>
        <div class="risk_info_value">
          {{ risk_route.wind_num ? risk_route.wind_num.area_ratio+'%' : '-' }}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          遭遇高海浪占比:
        </div>
        <div class="risk_info_value">
          {{ risk_route.wave_num ? risk_route.wave_num.area_ratio + '%' : '-' }}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          遭遇低能见度占比:
        </div>
        <div class="risk_info_value">
          {{ risk_route.vis_num ? risk_route.vis_num.area_ratio + '%' : '-' }}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          途径冰区占比:
        </div>
        <div class="risk_info_value">
          {{ risk_route.ice_sum != null && risk_route.ice_sum !== '' ? risk_route.ice_sum+'%' : '-' }}
        </div>
      </div>
      <div class="risk_info_one">
        <div class="risk_info_title">
          途径养殖区占比:
        </div>
        <div class="risk_info_value">
          {{ risk_route.fishing_port_num!=null && risk_route.fishing_port_num!=='' ? risk_route.fishing_port_num+'%' : '-' }}
        </div>
      </div>
    </div>
    <div class="risk_nav">
      <div class="risk_title">事故评级</div>
      <Star color="#f27629" :score="risk.malfunctionStar "></Star>
    </div>
    <div class="risk_info_box">
      <div class="risk_info_one" v-for="(item,index) in incidents" :key="index">
        {{item.incidentDate}}  {{ item.initialEventType || item.initialEvent }}
      </div>
    </div>
    <div class="risk_info_download">
      <el-button class="risk_info_download_btn" type="danger" size="small" @click="downloadRiskFile">
        下载风控报告详情
      </el-button>
      <el-button type="info" size="small" @click="riskClose">关 闭 返 回</el-button>
    </div>
  </div>
</template>

<script>
  import { getDomain,getShipRisk,getShipSpeedRisk,getShipRiskRoute,getShipImoIncident,getShipPsc,getRiskFilepath } from '../../api/api'
  import { parseArrayValueByObjectKeyToString,downloadFile } from '../../util/common'

  import Star from './star'
    export default {
      name: "risk",
      components:{
        Star
      },
      props:{
          ship:{
            type:Object,
            value:{}
          }
      },
      data(){
        return {
          risk:{},
          riskReason:{},
          ship_speed:{},
          risk_route:{},
          incidents:[],
          inspections:[],
          detentionNum:0,
          sailling:{},
          riskReasonLen:0,
          sarea:{"a":"远海航区","b":"近海航区","c":"沿海航区","d":"遮蔽航区","n":"陆地与内河","e":"邻国领土","A":"A级航段","B":"B级航段","C":"C级航段","f":"陆地与内河"}
        }
      },
      mounted(){
        this.getRisk();
        this.getRiskRoute();
        this.getRiskSpeed();
        this.getImoIncidents();
        this.getPsc();
      },
      methods: {
        getPsc(){
          if(this.ship.imo && this.ship.imo != null && this.ship.imo > 0){
            getShipPsc(this.ship.imo).then(res => {
              if(res && res.status===0){
                this.detentionNum = 0;
                this.inspections = res.inspections;
                for(let s in res.inspections){
                  if(res.inspections[s].ship.detention === 'yes') this.detentionNum++;
                }
              }
            });
          }
        },
        getRisk(){
          getShipRisk(this.ship.mmsi).then(res => {
            if(res && res.status === 0){
              let risk = res.data.r[0];
              let riskReasonJson = risk.riskReason !== '' ? JSON.parse(risk.riskReason) : {};
              let riskReason = {};
              for(let rk in riskReasonJson){
                riskReason['riskReanson'+rk] = riskReasonJson[rk]
              }
              this.riskReason = riskReason;
              this.riskReasonLen = Object.keys(riskReason).length;
              if(res.data.s){
                let saillings = res.data.s;
                for(let sr in saillings){
                  if(saillings[sr]['timeCode']===null){
                    risk['distanceSum'] = saillings[sr]['distanceSum']
                    risk['speedMean'] = saillings[sr]['speedMean']
                    break;
                  }
                }
                risk['dataAisQualityCombScore'] = risk['dataAisQualityCombScore'] ? Math.round(risk['dataAisQualityCombScore'] / 110 * 100) : -1
                risk['dataAisQualityCombScore'] = risk['dataAisQualityCombScore'] >= 0 ? (risk['dataAisQualityCombScore'] >= 75 ? risk['dataAisQualityCombScore'] + risk['dataAisQualityCombScore']+' (优)' : (risk['dataAisQualityCombScore'] >= 50 ? risk['dataAisQualityCombScore']+' (良)' : risk['dataAisQualityCombScore'] + ' (较差)')) : '-0'
                switch(risk['dailityActivityTimeSlot']){
                  case 'A':
                    risk['dailityActivityTimeSlot'] = '00:00 - 06:00'
                    break;
                  case 'B':
                    risk['dailityActivityTimeSlot'] = '06:00 - 12:00'
                    break;
                  case 'C':
                    risk['dailityActivityTimeSlot'] = '12:00 - 18:00'
                    break;
                  case 'D':
                    risk['dailityActivityTimeSlot'] = '18:00 - 00:00'
                    break;
                  default:
                    risk['dailityActivityTimeSlot'] = '无'
                    break;
                }
                if(risk.firstSecond && risk.firstSecond!=null && risk.firstSecond!==''){
                  let firstSecond = risk.firstSecond.split('');
                  if(firstSecond!=null && firstSecond.length > 0){
                    risk['firstSecond'] = parseArrayValueByObjectKeyToString(firstSecond,this.sarea)
                  }
                }
                this.sailling = res.data.s;
                this.risk = risk;
              }
            }
          });
        },
        getRiskRoute(){
          getShipRiskRoute(this.ship.mmsi).then(res => {
            if(res && res.status === 0){
              let rdata = res.data;
              if(rdata['wind_num'] !== '') rdata['wind_num'] = JSON.parse(rdata['wind_num'].replace(/'/ig,'"'));
              if(rdata['wave_num'] !== '') rdata['wave_num'] = JSON.parse(rdata['wave_num'].replace(/'/ig,'"'));
              if(rdata['vis_num'] !== '') rdata['vis_num'] = JSON.parse(rdata['vis_num'].replace(/'/ig,'"'));
              if(rdata['war_zone_num']!=null && rdata['war_zone_num'].length>0){
                let war_zone_str = '';
                for(let w in rdata['war_zone_num']){
                  war_zone_str += rdata['war_zone_num'][w]['area_label']+'<br/>'+rdata['war_zone_num'][w]['area_ratio']+'% '+(rdata['war_zone_num'][w]['stay_time']/3600).toFixed(1)+'h<br/>'
                }
                rdata['war_zone_str'] = war_zone_str;
              }
              if(rdata['pirate_num']!=null && rdata['pirate_num'].length>0){
                let pirate_str = '';
                for(let p in rdata['pirate_num']){
                  pirate_str += rdata['pirate_num'][p]['area_label']+'<br/>'+rdata['pirate_num'][p]['area_ratio']+'% '+(rdata['pirate_num'][p]['stay_time']/3600).toFixed(1)+'h<br/>'
                }
                rdata['pirate_str'] = pirate_str;
              }
              this.risk_route = rdata;
            }
          })
        },
        getRiskSpeed(){
          getShipSpeedRisk(this.ship.mmsi).then(res => {
            if(res && res.status === 0){
              this.ship_speed = res.data;
            }
          })
        },
        getImoIncidents(){
          getShipImoIncident(this.ship.imo,this.ship.mmsi).then(res => {
            if(res && res.status === 0){
              this.incidents = res.data;
            }
          })
        },
        riskClose(){
          this.$emit('shipRiskClose',null);
        },
        downloadRiskFile(){
          getRiskFilepath(this.ship.mmsi,'pdf').then(res => {
            if(res && res.status === 0){
              downloadFile('https://static.anlantech.cn/'+res.data.filepath,window.location.hash.substring(1),res.data.type);
            }
          });
        }
      }
    }
</script>

<style scoped>
  .risk_nav {
    width:94%;
    float:left;
    height: 1.6rem;
    padding-top:.3rem;
    margin: .3rem 1% .5rem 5%;
    text-indent: .5rem;
    background-color: rgba(200,200,200,0.1);
    border-left:6px solid rgb(84, 118, 153);
  }

  .risk_info_box {
    width:100%;
    float:left;
    margin:0 3% 1vh 3%;
  }

  .risk_info_one {
    width:90%;
    margin:0 5%;
    float:left;
    min-height:1.8rem;
    line-height: 1.8rem;
    font-size: .9rem;
  }

  .risk_alarm {
    width:90%;
    float:left;
    margin:.3rem 5%;
    color:rgb(230, 0, 0);
    font-size:.9rem;
    font-weight: bold;
  }

  .risk_info_download {
    height:3rem;
    width:100%;
    float:left;
    margin:1rem auto;
    text-align:center;
  }

  .risk_info_download_btn button {
    height:2rem;
    line-height: 1rem;
    text-align: center;
  }

  .risk_title {
    font-weight: bold;
    text-indent: 1rem;
    width:6rem;
    float:left;
  }

  .risk_head {
    height:9rem;
    width:90%;
    float:left;
    margin:.2rem 5% .5rem 5%;
    border-bottom: 1px solid rgba(200,200,200,0.2);
  }

  .risk_head_left {
    width:52%;
    height:8rem;
    float:left;
    margin-left:5%;
  }

  .risk_head_right {
    width:35%;
    height:6rem;
    float:right;
    margin-right:5%;
  }

  .risk_head_left_one {
    width:100%;
    min-width:12rem;
    float:left;
    height:1.4rem;
    font-size:.95rem;
    line-height:1.4rem;
    margin: 0 0 .3rem 0;
  }

  .risk_head_left_one_bar {
    width: .2rem;
    height:1.2rem;
    border-radius: .2rem;
    float:left;
    margin: .1rem .1rem 0 .2rem;
  }

  .risk_bar_color_one {
    background-color:#0098fa;
  }

  .risk_bar_color_two {
    background-color:#0cd9b5;
  }

  .risk_bar_color_three {
    background-color:#3b72ad;
  }

  .risk_bar_color_four {
    background-color:#fdcc00;
  }

  .risk_bar_color_five {
    background-color:#f27629;
  }

  .risk_head_left_one_title {
    width:4rem;
    float:left;
    margin: 0 .1rem 0 .2rem;
  }

  .risk_head_left_star {
    width:6.8rem;
    float:left;
    margin: .2rem 0 0 .1rem;
  }

  .risk_head_right_title {
    width:100%;
    float:left;
    height:1.6rem;
    font-size:1.1rem;
    font-weight: bold;
    color:grey;
    text-align: center;
    margin-top:2rem;
  }

  .risk_head_right_score{
    width:100%;
    float:left;
    height:2rem;
    line-height:2rem;
    font-size:2rem;
    font-weight: bold;
    color:#4ab7d2;
    text-align: center;
  }

  .risk_head_right_star {
    width:100%;
    float:left;
    text-align: center;
  }

  .risk_alarm_title {
    width:12rem;
    float:left;
    text-align: left;
    color:grey;
  }

  .risk_alarm_value {
    width:8rem;
    float:left;
    text-align: left;
    color:red;
  }

  .risk_info_title {
    width:11rem;
    float:left;
    color:grey;
    text-align: left;
    font-weight: bold;
  }

  .risk_info_value {
    width:9rem;
    float:left;
    color:black;
    text-align: left;
    font-weight: bold;
  }

  .risk_alarm_count {
    width:5rem;
    float:left;
    color:red;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/ship/risk.vue